import type { ProductVariation } from 'models/productsReferential';

export type StaticWorkspaceTabActions = StaticWorkspaceTabSetQuote | StaticWorkspaceTabUnsetQuote;

export function staticWorkspaceTabSetQuote(tabId: string, quoteId: string) {
  return { type: 'STATIC_WORKSPACE_SET_QUOTE' as const, tabId, quoteId };
}
export type StaticWorkspaceTabSetQuote = ReturnType<typeof staticWorkspaceTabSetQuote>;

export function staticWorkspaceTabUnsetQuote(tabId: string) {
  return { type: 'STATIC_WORKSPACE_UNSET_QUOTE' as const, tabId };
}
export type StaticWorkspaceTabUnsetQuote = ReturnType<typeof staticWorkspaceTabUnsetQuote>;

export function staticWorkspaceProductVariationSelected(tabId: string, productVariation: ProductVariation) {
  return {
    type: 'STATIC_WORKSPACE_PRODUCT_VARIATION_SELECTED' as const,
    tabId,
    productVariation,
  };
}
